<template>
  <v-layout class="w-100">
    <v-flex class="search-individual-select w-100">
      <v-autocomplete
              ref="autoCompleteField"
              v-model="model"
              @keydown="keydownIndividualName"
              @change="changeIndividualName"
              @keyup="keyupIndividualName"
              :search-input.sync="search"
              class="g-searchBar icon-magnifying-glass"
              :items="items"
              :placeholder="$t('search_for')"
              item-text="name"
              item-value="id"
              :loading="loading"
              hide-details
              append-icon=''
              :autofocus="false"
              return-object
              attach=".ex-search-space"
              :hide-no-data="!search"
      >
        <template slot="no-data">
          <v-list-tile-content class="no-data-available" v-text="$t('no_data_available')"></v-list-tile-content>
        </template>
        <template
                slot="item"
                slot-scope="{ item }"
        >
          <v-list-tile-content>
            <v-list-tile-title
                    v-html="item.name"
            ></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="item.count > 1">
            <v-list-tile-title
                    v-html="item.count"
            ></v-list-tile-title>
          </v-list-tile-action>
        </template>
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>

import { EventBus } from '../../../event-bus'

export default {
  name: 'SearchIndividualProducts',
  data () {
    return {
      products: [],
      model: null,
      offset: 1,
      loading: false,
      limit: 100,
      search: null,
      apiUrl: process.env.ROOT_API,
      typingTimer: {},
      previousSearchData: {},
      descriptionLimit: 20,
      isLogged: false
    }
  },
  computed: {
    items () {
      return this.products.map(product => {
        const name = product.name.length > this.descriptionLimit
          ? product.name.slice(0, this.descriptionLimit) + '...'
          : product.name
        const fullName = product.name
        return Object.assign({}, product, {name, fullName})
      })
    }
  },
  beforeMount () {
    if (localStorage && localStorage.getItem('token')) {
      this.isLogged = true
    }
  },
  created () {
    EventBus.$off('delete-search-autocomplete')
    EventBus.$on('delete-search-autocomplete', this.clearProducts)
  },
  methods: {
    keyupIndividualName (e) {
      this.loading = true
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        if (e.target && ((e.target.value && e.target.value.length > 2) || e.target.value.length === 0)) {
          this.search = e.target.value
          this.getIndividualProductsList()
        } else {
          this.loading = false
        }
      }, 500)
    },
    keydownIndividualName () {
      clearTimeout(this.typingTimer)
    },
    changeIndividualName (selectedProduct) {
      if (typeof selectedProduct === 'object') {
        if (selectedProduct.count > 1) {
          let data = {
            name: selectedProduct.name
          }
          this.$store.dispatch('categories/setSearch', data)
          if (this.$route.name === 'products') {
            EventBus.$emit('set-default-params')
          } else {
            this.$router.push({name: 'products'})
          }
        } else if (typeof selectedProduct.id === 'number') {
          this.$router.push(`/products/${selectedProduct.id}/${selectedProduct.fullName.replace(/\s+/g, '-')}`)
        }
      }
    },
    getIndividualProductsList () {
      const searchData = {offset: this.offset, limit: this.limit, search: this.search}
      let _payload = ''
      if (this.search) {
        _payload = `&search=${this.search}&page=${this.offset}&limit=${this.limit}`
      } else {
        this.loading = false
        return false
      }

      if (!this.previousSearchData.existItems && this.previousSearchData.offset === this.offset && this.previousSearchData.limit === this.limit && this.previousSearchData.search === this.search) {
        this.loading = false
        return false
      }

      this.$store.dispatch('products/getSearchIndividualProducts', {payload: _payload, isLogged: this.isLogged})
        .then(response => {
          this.products = []
          this.previousSearchData = {...searchData}
          this.previousSearchData.existItems = true

          if (response.length === 0) {
            this.previousSearchData.existItems = false
          }

          response.forEach(product => {
            product.name = ''
            product.ProductTranslations.forEach(productTranslation => {
              if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
                product.name = productTranslation.name.toUpperCase()
              } else if (!product.name) {
                product.name = productTranslation.name.toUpperCase()
              }
            })
            this.products.push({id: product.id, name: product.name})
          })

          this.products = [...this.products.reduce((mp, o) => {
            if (!mp.has(o.name)) {
              mp.set(o.name, Object.assign({ count: 0 }, o))
            }
            mp.get(o.name).count++
            return mp
          }, new Map()).values()]
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearProducts () {
      this.products = []
      this.model = null
      this.previousSearchData = {}
    }
  }
}
</script>

<style scoped>
  .search-individual-select {
      position: relative;
  }
  /*.search-individual-select i {*/
    /*position: absolute;*/
    /*right: 0;*/
    /*top: 20px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/global/components/SearchIndividualProducts.vue